import { Outlet } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";
import { TopBar } from "./TopBar";
import { WorkspaceProvider } from "@/hooks/use-workspace";

interface AdminLayoutProps {
  title?: string;
}

export function AdminLayout({ title }: AdminLayoutProps) {
  return (
    <WorkspaceProvider>
      <div className="flex h-screen bg-background">
        <AdminSidebar />
        <div className="flex flex-col flex-1 overflow-hidden">
          <TopBar title={title} />
          <main className="flex-1 overflow-auto p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </WorkspaceProvider>
  );
}
